// v2.8+E319 · Rider safety flag categories (dispatcher-assignable).
// Single source of truth for the Book Now form selector; the backend
// whitelists against this exact list before persisting.
export const RIDER_FLAGS = [
  "Flight Risk",
  "Possible Violent",
  "Intoxication Alert",
  "Nursing Home Patient",
  "ER Patient",
  "Police Hold",
  "Banned Rider",
  "High Risk",
];

// v2.8+E320 · Severity — critical flags get a stronger, pulsing red treatment
// vs. informational ones. Kept as a Set so lookups are O(1) everywhere.
export const CRITICAL_RIDER_FLAGS = new Set(["Banned Rider", "Possible Violent"]);
export const isCriticalFlag = (flag) => CRITICAL_RIDER_FLAGS.has(flag);
export const hasCriticalFlag = (flags) => Array.isArray(flags) && flags.some(isCriticalFlag);
